import React from 'react';
import { useEffect, useRef } from 'react';

interface IProps {
    children: React.ReactElement;
    className?: string;
    getWidth?(width: number): void;
}

export const NavItem = (props: IProps) => {
    const { children, className, getWidth } = props;
    const liRef = useRef(null);
    useEffect(() => {
        if (getWidth) {
            getWidth(liRef.current.offsetWidth);
        }
    }, [children, className]);

    return (
        <li
            className={`page-header-nav-item ${className ? className : ''}`}
            ref={liRef}
        >
            {children}
        </li>
    );
};
